type Tab = {
    name: string;
    value: number;
};

export const TABS: Record<string, Tab> = {
    USERS_TAB: { name: 'Users', value: 1 },
    RESOURCES_TAB: { name: 'Resources', value: 2 }
};
